import React, { useState, useEffect } from "react";
import { getOrganizations } from "../../controllers/OrganizationController";
import OrganizationBox from "./OrganizationBox";
import "./Organization.css";

function OrganizationsList({ onSelectOrganization }) {
    const [organizations, setOrganizations] = useState([]);
    const [selectedId, setSelectedId] = useState(null);

    useEffect(() => {
        getOrganizations()
            .then((data) => {
                setOrganizations(data || []);
            })
            .catch((error) => console.error("Error fetching organizations:", error));
    }, []);

    const handleSelect = (org) => {
        setSelectedId(org.id);
        onSelectOrganization(org);
    };

    return (
        <ul>
            {organizations.map((org) => (
                <li key={org.id}>
                    <OrganizationBox
                        organization={org}
                        onClick={() => handleSelect(org)}
                        isSelected={selectedId === org.id}
                    />
                </li>
            ))}
        </ul>
    );
}


export default OrganizationsList;
